import { Select } from 'antd'
import styled from 'styled-components'

const StyledFullWidthSelect = styled(Select)`
  width: 100%;
`

export default StyledFullWidthSelect
